import {useState, useEffect} from 'react';
import {Switch, useRouteMatch, NavLink} from "react-router-dom";
import AdvertiseBlock from "../../components/AdvertiseBlock";
import {useTranslation} from "react-i18next";
import DailyQuests from "../../components/Surveys/DailyQuests";
import PopularSurveys from "../../components/Surveys/PopularSurveys";
import InterestedSurveys from "../../components/Surveys/InterestedSurveys";

import '../../assets/styles/surveys/surveyListPage.scss';
import ActiveList from "./ActiveList";
import FinishedList from "./FinishedList";
import {useAuth} from "../../services/use-auth";
import GuardedRoute from "../../components/Route/GuardedRoute";

export default function SurveyList() {
    const { t } = useTranslation();
    const { path, url } = useRouteMatch();
    const auth = useAuth();
    const [surveysData, setSurveysData] = useState({
        surveys: [],
        finishedSurveys: [],
        topSurveysByPassedUserCount: [],
        interestedSurveys: [],
        quests: [],
        categories: [],
        pinnedSurveys: [],
        loaded: false
    });

    useEffect(() => {
        fetch("/api/v1/spa/surveys")
            .then(res => res.json())
            .then(
                (result) => {
                    setSurveysData({...result, loaded: true});
                }
            )
    }, []);

    return (
        <section id="quiz">
            <div className="container">
                <AdvertiseBlock unitId="surveys1" blockLocation="top" />
                { !!auth.user && <nav className="navigation-survey">
                    <NavLink exact activeClassName="active"
                       to={`${url}`}>{t('surveys.tabs.active')}</NavLink>
                    <NavLink exact activeClassName="active"
                       to={`${url}/finished`}>{t('surveys.tabs.finished')}</NavLink>
                </nav> }
                <div className="survey-grid">
                    <div>
                        <Switch>
                            <GuardedRoute exact path={path}>
                                { surveysData.loaded && <ActiveList
                                    pinnedSurveys={surveysData.pinnedSurveys}
                                    surveys={surveysData.surveys}
                                    categories={surveysData.categories}
                                /> }
                            </GuardedRoute>
                            <GuardedRoute exact path={`${path}/finished`}>
                                {surveysData.loaded && <FinishedList
                                    surveys={surveysData.finishedSurveys}
                                    categories={surveysData.categories}
                                /> }
                            </GuardedRoute>
                        </Switch>
                    </div>
                    <div>
                        {
                            !!surveysData.quests.length && <DailyQuests quests={surveysData.quests} />
                        }
                        <AdvertiseBlock unitId="surveys3" blockLocation="sidebar" />
                        {!!surveysData.topSurveysByPassedUserCount.length && <PopularSurveys surveys={surveysData.topSurveysByPassedUserCount} /> }
                        {!!surveysData.interestedSurveys.length && <InterestedSurveys surveys={surveysData.interestedSurveys} />}
                    </div>
                </div>
            </div>
        </section>
    );
}
